/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * @class MBP Logger
 */
import {
    logInfo, logDebug, logWarning, logError, // Helpers
    ErrorModal, // Components
} from './mbpLog';
import middlewareLogger from './helpers/logger-middleware';

export default {
    logInfo,
    logError,
    logWarning,
    logDebug,

    ErrorModal,

    middlewareLogger,
};
